import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const logoUrl = 'https://cdn.magicpatterns.com/uploads/c9BJ1X3xKAxokqvkAeBFyG/equipme-coaching-white-logo-scaled-768x126.png';
  return <>
      {/* Trust Announcement Bar */}
      <div className="bg-brand-deep-purple text-brand-off-white py-2 text-center text-xs md:text-sm border-b border-brand-plum/30" data-id="element-232">
        <div className="max-w-7xl mx-auto px-6" data-id="element-233">
          <span className="font-medium" data-id="element-234">
            Independent. Impartial. Confidential.
          </span>
          <span className="hidden md:inline text-brand-mauve mx-2" data-id="element-235">—</span>
          <span className="text-brand-mauve" data-id="element-236">
            Supporting Australian organisations for over 20 years
          </span>
        </div>
      </div>

      <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-charcoal/98 backdrop-blur-md py-3 shadow-lg' : 'bg-brand-charcoal py-4'}`} data-id="element-237">
        {/* Gradient line on scroll */}
        {isScrolled && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-brand-teal via-brand-magenta to-brand-orange" data-id="element-238"></div>}

        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-239">
          <a href="#" className="z-50" data-id="element-240">
            <img src={logoUrl} alt="EquipMe Coaching & Consulting" className="h-[42px] md:h-[53px] w-auto" data-id="element-241" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-242">
            <a href="#" className="text-brand-off-white hover:text-brand-lime transition-colors text-sm font-medium" data-id="element-243">
              Home
            </a>
            <a href="#about" className="text-brand-off-white hover:text-brand-lime transition-colors text-sm font-medium" data-id="element-244">
              About
            </a>

            <div className="relative group" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-245">
              <button className="flex items-center gap-1 text-brand-off-white hover:text-brand-lime transition-colors text-sm font-medium py-2" data-id="element-246">
                Services{' '}
                <ChevronDown size={14} className={`transition-transform ${servicesOpen ? 'rotate-180' : ''}`} data-id="element-247" />
              </button>

              <AnimatePresence data-id="element-248">
                {servicesOpen && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 w-80 bg-white rounded-sm shadow-2xl overflow-hidden border border-gray-100 mt-2" data-id="element-249">
                    <div className="flex flex-col" data-id="element-250">
                      <a href="#ombuds" className="px-6 py-4 hover:bg-brand-off-white text-brand-charcoal text-sm font-medium transition-colors border-l-4 border-transparent hover:border-brand-magenta" data-id="element-251">
                        External Ombuds & Conflict Resolution
                      </a>
                      <a href="#culture" className="px-6 py-4 hover:bg-brand-off-white text-brand-charcoal text-sm font-medium transition-colors border-l-4 border-transparent hover:border-brand-teal" data-id="element-252">
                        Culture, DEI & Workplace Transformation
                      </a>
                      <a href="#leadership" className="px-6 py-4 hover:bg-brand-off-white text-brand-charcoal text-sm font-medium transition-colors border-l-4 border-transparent hover:border-brand-orange" data-id="element-253">
                        Leadership Coaching & Development
                      </a>
                      <a href="#advisory" className="px-6 py-4 hover:bg-brand-off-white text-brand-charcoal text-sm font-medium transition-colors border-l-4 border-transparent hover:border-brand-plum" data-id="element-254">
                        Workplace Advisory
                      </a>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <a href="#resources" className="text-brand-off-white hover:text-brand-lime transition-colors text-sm font-medium" data-id="element-255">
              Resources
            </a>
            <a href="#contact" className="text-brand-off-white hover:text-brand-lime transition-colors text-sm font-medium" data-id="element-256">
              Contact
            </a>
          </nav>

          <div className="hidden lg:block" data-id="element-257">
            <a href="#consultation" className="bg-brand-magenta hover:bg-brand-plum text-white px-6 py-3 rounded-sm font-semibold text-sm transition-all hover:shadow-lg hover:shadow-brand-magenta/30" data-id="element-258">
              Book a confidential consultation
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-brand-off-white z-50" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-259">
            {mobileMenuOpen ? <X size={28} data-id="element-260" /> : <Menu size={28} data-id="element-261" />}
          </button>
        </div>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-262">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: '100vh'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="fixed inset-0 bg-white/95 backdrop-blur-md pt-24 px-6 lg:hidden overflow-y-auto" data-id="element-263">
              <div className="flex flex-col gap-6" data-id="element-264">
                <a href="#" className="text-2xl text-brand-charcoal font-serif border-b border-gray-200 pb-4" data-id="element-265">
                  Home
                </a>
                <a href="#about" className="text-2xl text-brand-charcoal font-serif border-b border-gray-200 pb-4" data-id="element-266">
                  About
                </a>
                <div className="flex flex-col gap-4 border-b border-gray-200 pb-4" data-id="element-267">
                  <span className="text-2xl text-brand-charcoal font-serif" data-id="element-268">
                    Services
                  </span>
                  <a href="#ombuds" className="text-brand-teal pl-4 font-medium" data-id="element-269">
                    External Ombuds & Conflict Resolution
                  </a>
                  <a href="#culture" className="text-brand-teal pl-4 font-medium" data-id="element-270">
                    Culture, DEI & Workplace Transformation
                  </a>
                  <a href="#leadership" className="text-brand-teal pl-4 font-medium" data-id="element-271">
                    Leadership Coaching & Development
                  </a>
                  <a href="#advisory" className="text-brand-teal pl-4 font-medium" data-id="element-272">
                    Workplace Advisory
                  </a>
                </div>
                <a href="#resources" className="text-2xl text-brand-charcoal font-serif border-b border-gray-200 pb-4" data-id="element-273">
                  Resources
                </a>
                <a href="#contact" className="text-2xl text-brand-charcoal font-serif border-b border-gray-200 pb-4" data-id="element-274">
                  Contact
                </a>

                <a href="#consultation" className="bg-brand-magenta text-white text-center px-6 py-4 rounded-sm font-semibold mt-4 shadow-lg shadow-brand-magenta/30" data-id="element-275">
                  Book a confidential consultation
                </a>
              </div>
            </motion.div>}
        </AnimatePresence>
      </header>
    </>;
}